import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBell2Snooze: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBell2Snooze"><Path fillRule="evenodd" clipRule="evenodd" d="M4.70162 8.94258C4.89608 5.05346 8.10602 2 12 2C15.894 2 19.1039 5.05346 19.2984 8.94258L19.4883 12.7405L21 15.7639V18H16.9C16.4367 20.2822 14.419 22 12 22C9.58104 22 7.56329 20.2822 7.10002 18H3V15.7639L4.51173 12.7405L4.70162 8.94258ZM9.17071 18C9.58254 19.1652 10.6938 20 12 20C13.3062 20 14.4175 19.1652 14.8293 18H9.17071ZM9.5 7.5V9.5H11.5858L9.5 11.5858V13.5H14.5V11.5H12.4142L14.5 9.41421V7.5H9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBell2Snooze;
